@if (!carregando) {
  <div class="dashboard-resultados-page" [@esvanecerDesvanecer]="'in'">
    <div class="dashboard-resultados-topbar">
      <div>
        <h1>Dashboard &gt; Resultados</h1>
        <p>Resumo comercial diario, produtos, visitas, ticket medio e metas do periodo.</p>
      </div>

      @if (abaAtiva !== 'reativacoes') {
      <div class="dashboard-resultados-filtros">
        <label>
          <span>Inicio</span>
          <input type="date" [(ngModel)]="dataInicio" [ngModelOptions]="{standalone: true}">
        </label>
        <label>
          <span>Fim</span>
          <input [appPeriodoFinal]="dataInicio" type="date" [(ngModel)]="dataFim" [ngModelOptions]="{standalone: true}">
          @if (erroPeriodo) { <small class="text-danger" role="alert">{{ erroPeriodo }}</small> }
        </label>
        <label>
          <span>Tipo</span>
          <select [(ngModel)]="tipoDados" [ngModelOptions]="{standalone: true}">
            <option value="FATURADO">Faturado</option>
            <option value="GERAL">Geral</option>
          </select>
        </label>
        <label>
          <span>Tipo de pedido</span>
          <select [(ngModel)]="tipoPedidoFiltro" [ngModelOptions]="{standalone: true}">
            <option value="">Todos</option>
            @for (tipoPedido of tiposPedidosDisponiveis; track tipoPedido) {
              <option [value]="tipoPedido">{{ tipoPedido }}</option>
            }
          </select>
        </label>
        <label>
          <span>Vendedor</span>
          <input type="text" [(ngModel)]="vendedorFiltro" [ngModelOptions]="{standalone: true}" placeholder="Todos" autocomplete="off" (input)="alterarVendedorFiltro()" (focus)="filtroAtivo = 'vendedor'" (blur)="fecharPesquisa()">
          @if (filtroAtivo == 'vendedor') {
            <div class="dashboard-resultados-searchbox">
              <button type="button" (mousedown)="vendedorFiltro = ''; vendedorFiltroId = null; filtroAtivo = ''">Todos os vendedores</button>
              @for (vendedor of vendedoresFiltrados(); track vendedor.id) {
                <button type="button" (mousedown)="selecionarVendedor(vendedor)">
                  <b>{{ vendedor.fullname }}</b>
                </button>
              }
            </div>
          }
        </label>
        <label>
          <span>Cliente</span>
          <input type="text" [(ngModel)]="clienteFiltro" [ngModelOptions]="{standalone: true}" placeholder="Todos" autocomplete="off" (input)="alterarClienteFiltro()" (focus)="filtroAtivo = 'cliente'" (blur)="fecharPesquisa()">
          @if (filtroAtivo == 'cliente') {
            <div class="dashboard-resultados-searchbox">
              <button type="button" (mousedown)="clienteFiltro = ''; clienteFiltroId = null; filtroAtivo = ''">Todos os clientes</button>
              @for (cliente of clientesFiltrados(); track cliente.id) {
                <button type="button" (mousedown)="selecionarCliente(cliente)">
                  <b>{{ cliente.name }}</b>
                  <small>{{ cliente.client_document }}</small>
                </button>
              }
            </div>
          }
        </label>
        <label>
          <span>Produto</span>
          <input type="text" [(ngModel)]="produtoFiltro" [ngModelOptions]="{standalone: true}" placeholder="Todos" autocomplete="off" (input)="alterarProdutoFiltro()" (focus)="filtroAtivo = 'produto'" (blur)="fecharPesquisa()">
          @if (filtroAtivo == 'produto') {
            <div class="dashboard-resultados-searchbox">
              <button type="button" (mousedown)="produtoFiltro = ''; produtoFiltroId = null; filtroAtivo = ''">Todos os produtos</button>
              @for (produto of produtosFiltrados(); track produto.id) {
                <button type="button" (mousedown)="selecionarProduto(produto)">
                  <b>{{ produto.name }}</b>
                  <small>{{ produto.codigo }}</small>
                </button>
              }
            </div>
          }
        </label>
        <label>
          <span>Grupo</span>
          <button class="dashboard-resultados-multibox" type="button" (click)="abrirFiltroGrupo('grupo')" (blur)="fecharFiltroGrupo()">
            {{ textoGrupoFiltro('grupo') }}
          </button>
          @if (grupoFiltroAtivo == 'grupo') {
            <div class="dashboard-resultados-checkboxbox" (mousedown)="$event.preventDefault()">
              <button class="dashboard-resultados-checkbox-clear" type="button" (click)="limparGrupoFiltro('grupo', $event)">Todos</button>
              @for (grupo of gruposDisponiveis; track grupo) {
                <label class="dashboard-resultados-check-option" (click)="alternarGrupoSelecionado('grupo', grupo, $event)">
                  <input type="checkbox" [checked]="grupoSelecionado('grupo', grupo)" readonly>
                  <span>{{ grupo }}</span>
                </label>
              }
            </div>
          }
        </label>
        <label>
          <span>Grupo2</span>
          <button class="dashboard-resultados-multibox" type="button" (click)="abrirFiltroGrupo('grupo2')" (blur)="fecharFiltroGrupo()">
            {{ textoGrupoFiltro('grupo2') }}
          </button>
          @if (grupoFiltroAtivo == 'grupo2') {
            <div class="dashboard-resultados-checkboxbox" (mousedown)="$event.preventDefault()">
              <button class="dashboard-resultados-checkbox-clear" type="button" (click)="limparGrupoFiltro('grupo2', $event)">Todos</button>
              @for (grupo2 of grupos2Disponiveis; track grupo2) {
                <label class="dashboard-resultados-check-option" (click)="alternarGrupoSelecionado('grupo2', grupo2, $event)">
                  <input type="checkbox" [checked]="grupoSelecionado('grupo2', grupo2)" readonly>
                  <span>{{ grupo2 }}</span>
                </label>
              }
            </div>
          }
        </label>
        <label>
          <span>Grupo3</span>
          <button class="dashboard-resultados-multibox" type="button" (click)="abrirFiltroGrupo('grupo3')" (blur)="fecharFiltroGrupo()">
            {{ textoGrupoFiltro('grupo3') }}
          </button>
          @if (grupoFiltroAtivo == 'grupo3') {
            <div class="dashboard-resultados-checkboxbox" (mousedown)="$event.preventDefault()">
              <button class="dashboard-resultados-checkbox-clear" type="button" (click)="limparGrupoFiltro('grupo3', $event)">Todos</button>
              @for (grupo3 of grupos3Disponiveis; track grupo3) {
                <label class="dashboard-resultados-check-option" (click)="alternarGrupoSelecionado('grupo3', grupo3, $event)">
                  <input type="checkbox" [checked]="grupoSelecionado('grupo3', grupo3)" readonly>
                  <span>{{ grupo3 }}</span>
                </label>
              }
            </div>
          }
        </label>
        <button type="button" (click)="alterarFiltroBase()"><i class="fa fa-refresh" aria-hidden="true"></i> Atualizar</button>
      </div>
      }
    </div>

    <nav class="dashboard-resultados-abas" aria-label="Relatórios de resultados">
      @for (aba of abas; track aba.id) {
        <button type="button" [class.ativa]="abaAtiva === aba.id" [attr.aria-current]="abaAtiva === aba.id ? 'page' : null" (click)="selecionarAba(aba.id)"><i class="fa" [ngClass]="aba.icone" aria-hidden="true"></i>{{ aba.titulo }}</button>
      }
    </nav>

    @if (abaAtiva === 'reativacoes') {
      <h2 class="reativacoes-titulo">Reativações de clientes</h2>
      <p class="reativacoes-subtitulo">Clientes recuperados no período selecionado.</p>
      <section class="dashboard-resultados-panel reativacoes-filtros-panel">
        <div class="dashboard-resultados-filtros reativacoes-filtros">
          <label><span>Início</span><input type="date" [(ngModel)]="reativacoesInicio" [ngModelOptions]="{standalone: true}"></label>
          <label><span>Fim</span><input [appPeriodoFinal]="reativacoesInicio" type="date" [(ngModel)]="reativacoesFim" [ngModelOptions]="{standalone: true}"></label>
          <label class="reativacoes-vendedor"><span>Vendedor</span>
            <select [(ngModel)]="reativacoesVendedorId" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">Todos os permitidos</option>
              @for (vendedor of reativacoes?.vendedores || []; track vendedor.id) {
                <option [ngValue]="vendedor.id">{{ vendedor.fullname }}</option>
              }
            </select>
          </label>
          <label><span>Região</span>
            <select [(ngModel)]="reativacoesRegiao" [ngModelOptions]="{standalone: true}">
              <option value="">Todas as regiões</option>
              @for (regiao of reativacoes?.regioes || []; track regiao) {
                <option [value]="regiao">{{ regiao }}</option>
              }
            </select>
          </label>
          <button type="button" [disabled]="reativacoesCarregando" (click)="carregarReativacoes()"><i class="fa fa-refresh" [class.fa-spin]="reativacoesCarregando" aria-hidden="true"></i>{{ reativacoesCarregando ? 'Carregando...' : 'Atualizar' }}</button>
        </div>
        <small class="reativacoes-ajuda">Período pela data de reativação. Vendedores disponíveis conforme seu perfil de acesso.</small>
      </section>
      @if (reativacoesErro) { <p role="alert" class="alert alert-danger">{{ reativacoesErro }}</p> }
      @if (reativacoesCarregando) { <p role="status">Carregando reativações...</p> }
      @if (reativacoes && !reativacoesCarregando) {
        <div class="reativacoes-cards">
          <div class="dashboard-resultados-panel reativacoes-card"><div class="reativacoes-card-icone"><i class="fa fa-users" aria-hidden="true"></i></div><div class="reativacoes-card-conteudo"><span>Clientes recuperados</span><b>{{ reativacoes.totalClientes | number:'1.0-0' }}</b><small>Clientes únicos no período</small></div></div>
          <div class="dashboard-resultados-panel reativacoes-card"><div class="reativacoes-card-icone"><i class="fa fa-cube" aria-hidden="true"></i></div><div class="reativacoes-card-conteudo"><span>Volume total</span><b>{{ reativacoes.volumeTotal | number:'1.0-2' }} L</b><small>Volume dos pedidos de reativação</small></div></div>
          <div class="dashboard-resultados-panel reativacoes-card"><div class="reativacoes-card-icone"><i class="fa fa-database" aria-hidden="true"></i></div><div class="reativacoes-card-conteudo"><span>Valor total</span><b>{{ reativacoes.valorTotal | currency:'BRL' }}</b><small>Valor dos pedidos de reativação</small></div></div>
        </div>
        <section class="dashboard-resultados-panel">
          <div class="dashboard-resultados-panel-header"><div><h2>Clientes reativados</h2><small>Detalhamento por cliente e vendedor</small></div><span>{{ reativacoes.clientes.length | number:'1.0-0' }} registros</span></div>
          <div class="table-responsive">
            <table class="table table-sm dashboard-resultados-table reativacoes-table mb-0" aria-label="Clientes reativados">
              <thead><tr><th>Código</th><th>Cliente</th><th>Vendedor</th><th>Região</th><th>Última compra</th><th>Reativação</th><th>Dias sem compra</th><th class="text-right">Volume</th><th class="text-right">Valor</th></tr></thead>
              <tbody>
                @for (item of reativacoesLinhas; track $index) {
                  <tr><td>{{ item.codigoErp || '—' }}</td><td>{{ item.cliente }}</td><td>{{ item.vendedor }}</td><td>{{ item.regiao || '—' }}</td><td>{{ item.ultimaCompra ? (item.ultimaCompra | date:'dd/MM/yyyy') : '—' }}</td><td>{{ item.reativacao | date:'dd/MM/yyyy' }}</td><td><span class="reativacoes-dias" [class.sem-historico]="!item.ultimaCompra">{{ item.ultimaCompra ? item.diasSemCompra + ' dias' : 'Sem histórico' }}</span></td><td class="text-right">{{ item.volume | number:'1.0-2' }} L</td><td class="text-right">{{ item.valor | currency:'BRL' }}</td></tr>
                }
                @if (!reativacoes.clientes.length) { <tr><td colspan="9" class="text-center dashboard-resultados-empty">Nenhuma reativação para o período e filtros selecionados.</td></tr> }
              </tbody>
              <tfoot><tr><th>Total</th><th colspan="6">{{ reativacoes.totalClientes | number:'1.0-0' }} clientes</th><th class="text-right">{{ reativacoes.volumeTotal | number:'1.0-2' }} L</th><th class="text-right">{{ reativacoes.valorTotal | currency:'BRL' }}</th></tr></tfoot>
            </table>
          </div>
          <div class="reativacoes-paginacao">
            <small>{{ reativacoes.clientes.length | number:'1.0-0' }} registros · Página {{ reativacoesPagina }} de {{ reativacoesTotalPaginas }}</small>
            <div><button type="button" [disabled]="reativacoesPagina <= 1" (click)="reativacoesPagina = reativacoesPagina - 1">Anterior</button><button type="button" [disabled]="reativacoesPagina >= reativacoesTotalPaginas" (click)="reativacoesPagina = reativacoesPagina + 1">Próxima</button></div>
          </div>
        </section>
      }
    }

    @if (abaAtiva === 'resultados') {
    @if (metasSankhyaPermitidas) {
      <section class="dashboard-resultados-panel dashboard-sankhya">
        <div class="dashboard-resultados-panel-header">
          <div><h2>Consulta de metas × objetivo do mês</h2><small>Mês selecionado · Independente dos filtros do dashboard</small></div>
          <div class="sankhya-actions">
            @if (metasSankhyaConsulta) { <button type="button" class="dashboard-resultados-abertura-action" (click)="metasSankhyaExibidas = !metasSankhyaExibidas" [attr.aria-expanded]="metasSankhyaExibidas" aria-controls="sankhya-resultados">{{ metasSankhyaExibidas ? 'Ocultar' : 'Exibir' }}</button> }
            <label class="sankhya-mes">Mês
              <select [(ngModel)]="mesSankhya" [ngModelOptions]="{standalone: true}" (ngModelChange)="alterarMesSankhya()" [disabled]="metasSankhyaCarregando">
                @for (mes of mesesSankhya; track mes.valor) { <option [value]="mes.valor">{{ mes.descricao }}</option> }
              </select>
            </label>
            <button type="button" class="dashboard-resultados-abertura-action" [disabled]="metasSankhyaCarregando" (click)="consultarMetasSankhya()">{{ metasSankhyaCarregando ? 'Consultando...' : 'Consultar' }}</button>
          </div>
        </div>
        @if (metasSankhyaErro) { <p role="alert" class="text-danger">{{ metasSankhyaErro }}</p> }
        @if (metasSankhyaConsulta) { <p class="sankhya-consulta">Última consulta concluída: {{ metasSankhyaConsulta | date:'dd/MM/yyyy HH:mm:ss' }} · Ordem: código do vendedor</p> }
        <div id="sankhya-resultados" [hidden]="!metasSankhyaExibidas" [attr.aria-busy]="metasSankhyaCarregando">
          @if (metasSankhyaConsulta && !metasSankhyaGrupos.length) { <p>Nenhum objetivo encontrado para os vendedores permitidos no mês selecionado.</p> }
          @for (grupo of metasSankhyaGrupos; track grupo.codvend) {
            <div class="sankhya-vendedor"><strong>{{ grupo.codvend }} — {{ grupo.vendedor }}</strong><small>Região: {{ grupo.regiao }} · Supervisor: {{ grupo.supervisor }}</small></div>
            <div class="table-responsive">
              <table class="table table-sm dashboard-resultados-table sankhya-table" [attr.aria-label]="'Metas de ' + grupo.vendedor">
                <thead><tr><th>Indicador</th><th>Referência</th><th>Região</th><th class="text-right">Objetivo</th><th class="text-right">Realizado</th><th class="text-right">Atingimento</th></tr></thead>
                <tbody>
                  @for (linha of grupo.linhas; track $index) {
                    <tr><td>{{ linha.indicador }}</td><td>{{ linha.referencia | date:'MM/yyyy' }}</td><td>{{ linha.regiao }}</td><td class="text-right">{{ formatarMetaSankhya(linha.objetivo, linha.codtipo) }}</td><td class="text-right">{{ formatarMetaSankhya(linha.realizado, linha.codtipo) }}</td><td><div class="sankhya-atingimento"><div class="sankhya-trilha" aria-hidden="true"><div [style.width.%]="larguraMetaSankhya(linha.percentual)"></div></div><span>{{ linha.percentual == null ? '—' : (linha.percentual | number:'1.2-2') + '%' }}</span></div></td></tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </section>
    }

    <div class="dashboard-resultados-kpis">
      <div class="dashboard-resultados-kpi">
        <span>Vendas em reais</span>
        <strong>{{ totalVendasReais | currency: 'BRL' }}</strong>
      </div>

      <div class="dashboard-resultados-kpi">
        <span>Vendas em litros</span>
        <strong>{{ totalVendasLitros | number: '1.0-0' }} L</strong>
      </div>

      <div class="dashboard-resultados-kpi">
        <span>Numero de pedidos</span>
        <strong>{{ totalPedidos | number: '1.0-0' }}</strong>
      </div>

      <div class="dashboard-resultados-kpi">
        <span>Ticket medio</span>
        <strong>{{ ticketMedioGeral | currency: 'BRL' }}</strong>
      </div>
    </div>

    <div class="dashboard-resultados-grid dashboard-resultados-grid-duo">
      <section class="dashboard-resultados-panel">
        <div class="dashboard-resultados-panel-header">
          <h2>Vendas em reais por dia</h2>
          <span>Total {{ totalVendasReais | currency: 'BRL' }}</span>
        </div>

        <div class="dashboard-resultados-bars">
          @for (resultado of resultadosDias; track resultado.dia) {
            <div class="dashboard-resultados-bar-item">
              <div class="dashboard-resultados-bar-track">
                <div class="dashboard-resultados-bar dashboard-resultados-bar-blue" [style.height.%]="altura(resultado.vendasReais, maxVendasReais)">
                  <b>{{ resumoValor(resultado.vendasReais) }}</b>
                </div>
              </div>
              <span>{{ resultado.dia }}</span>
            </div>
          }
        </div>
      </section>

      <section class="dashboard-resultados-panel">
        <div class="dashboard-resultados-panel-header">
          <h2>Vendas em litros por dia</h2>
          <span>Total {{ totalVendasLitros | number: '1.0-0' }} L</span>
        </div>

        <div class="dashboard-resultados-bars">
          @for (resultado of resultadosDias; track resultado.dia) {
            <div class="dashboard-resultados-bar-item">
              <div class="dashboard-resultados-bar-track">
                <div class="dashboard-resultados-bar dashboard-resultados-bar-green" [style.height.%]="altura(resultado.vendasLitros, maxVendasLitros)">
                  <b>{{ resumoValor(resultado.vendasLitros) }} L</b>
                </div>
              </div>
              <span>{{ resultado.dia }}</span>
            </div>
          }
        </div>
      </section>
    </div>

    <section class="dashboard-resultados-panel dashboard-resultados-canais">
      <div class="dashboard-resultados-panel-header">
        <h2>Vendas externo / interno por vendedor</h2>
        <div class="dashboard-resultados-panel-actions">
          <span>Total {{ totalVendasCanais | currency: 'BRL' }}</span>
          <button type="button" (click)="exibirVendasCanais = !exibirVendasCanais">
            {{ exibirVendasCanais ? 'Ocultar lista' : 'Mostrar lista' }}
          </button>
        </div>
      </div>

      <div class="dashboard-resultados-canais-summary">
        <div>
          <span>Venda externa</span>
          <b>{{ totalVendasExternas | currency: 'BRL' }}</b>
        </div>
        <div>
          <span>Venda interna</span>
          <b>{{ totalVendasInternas | currency: 'BRL' }}</b>
        </div>
        <div>
          <span>Total</span>
          <b>{{ totalVendasCanais | currency: 'BRL' }}</b>
        </div>
      </div>

      @if (exibirVendasCanais) {
        <div class="table-responsive">
          <table class="table table-sm dashboard-resultados-table mb-0">
            <thead>
              <tr>
                <th>Vendedor</th>
                <th class="text-right">Venda externa</th>
                <th class="text-right">Venda interna</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              @for (canal of vendasCanais; track canal.sellerId) {
                <tr>
                  <td>{{ canal.vendedor }}</td>
                  <td class="text-right">{{ canal.vendasExternas | currency: 'BRL' }}</td>
                  <td class="text-right">{{ canal.vendasInternas | currency: 'BRL' }}</td>
                  <td class="text-right"><b>{{ canal.total | currency: 'BRL' }}</b></td>
                </tr>
              }
              @if (vendasCanais.length == 0) {
                <tr>
                  <td colspan="4" class="text-center dashboard-resultados-empty">Sem vendas para o periodo e filtros selecionados.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>

    <div class="dashboard-resultados-grid dashboard-resultados-grid-ticket">
      <section class="dashboard-resultados-panel">
        <div class="dashboard-resultados-panel-header">
          <h2>Ticket medio por dia</h2>
          <span>Media {{ ticketMedioGeral | currency: 'BRL' }}</span>
        </div>

        <div class="dashboard-resultados-area-chart">
          <svg viewBox="0 0 100 90" preserveAspectRatio="none">
            <defs>
              <linearGradient id="ticketGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#73c6e8" stop-opacity="0.58"></stop>
                <stop offset="100%" stop-color="#73c6e8" stop-opacity="0.04"></stop>
              </linearGradient>
            </defs>
            <polygon [attr.points]="'5,85 ' + pontosTicketMedio() + ' 95,85'" fill="url(#ticketGradient)"></polygon>
            <polyline [attr.points]="pontosTicketMedio()" fill="none" stroke="#8ed0ee" stroke-width="2"></polyline>
          </svg>
          @for (ponto of pontosTicketMedioDetalhe(); track ponto.dia) {
            <div class="dashboard-resultados-ticket-label" [style.left.%]="ponto.x" [style.top.%]="ponto.y">
              <b>{{ ponto.valor | currency: 'BRL' }}</b>
              <span>{{ ponto.dia }}</span>
            </div>
          }
        </div>
      </section>
    </div>

    <div class="dashboard-resultados-grid dashboard-resultados-grid-main">
      <section class="dashboard-resultados-panel">
        <div class="dashboard-resultados-panel-header">
          <h2>Numero de pedidos</h2>
          <span>{{ totalPedidos | number: '1.0-0' }} pedidos</span>
        </div>

        <div class="dashboard-resultados-pedidos-bars">
          @for (resultado of resultadosDias; track resultado.dia) {
            <div class="dashboard-resultados-pedidos-row">
              <span>{{ resultado.dia }}</span>
              <div class="dashboard-resultados-horizontal-track">
                <div [style.width.%]="largura(resultado.pedidos, maxPedidos)"></div>
              </div>
              <b>{{ resultado.pedidos }}</b>
            </div>
          }
        </div>
      </section>

      <section class="dashboard-resultados-panel">
        <div class="dashboard-resultados-panel-header">
          <h2>Top 10 produtos e quantidade vendida</h2>
          <label class="dashboard-resultados-select">
            <span>Ordenar por</span>
            <select [(ngModel)]="ordenacaoProdutos" (change)="atualizar()">
              <option value="quantidade">Quantidade</option>
              <option value="litros">Litros</option>
              <option value="valor">R$</option>
            </select>
          </label>
        </div>

        <div class="table-responsive">
          <table class="table table-sm dashboard-resultados-table mb-0">
            <thead>
              <tr>
                <th>Produto</th>
                <th class="text-right">Qtde vendida</th>
                <th class="text-right">Litros</th>
                <th class="text-right">Vendas R$</th>
              </tr>
            </thead>
            <tbody>
              @for (produto of produtos; track produto.posicao) {
                <tr>
                  <td><span class="dashboard-resultados-rank">{{ produto.posicao }}</span>{{ produto.produto }}</td>
                  <td class="text-right">{{ produto.quantidade | number: '1.0-0' }} un</td>
                  <td class="text-right">{{ produto.litros | number: '1.0-0' }} L</td>
                  <td class="text-right">{{ produto.vendasReais | currency: 'BRL' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div class="dashboard-resultados-grid dashboard-resultados-grid-duo">
      <section class="dashboard-resultados-panel">
        <div class="dashboard-resultados-panel-header">
          <h2>Top 10 clientes</h2>
          <label class="dashboard-resultados-select">
            <span>Ordenar por</span>
            <select [(ngModel)]="ordenacaoClientes" (change)="atualizar()">
              <option value="quantidade">Quantidade</option>
              <option value="litros">Litros</option>
              <option value="valor">R$</option>
            </select>
          </label>
        </div>

        <div class="table-responsive">
          <table class="table table-sm dashboard-resultados-table mb-0">
            <thead>
              <tr>
                <th>Cliente</th>
                <th class="text-right">Qtde vendida</th>
                <th class="text-right">Litros</th>
                <th class="text-right">Vendas R$</th>
              </tr>
            </thead>
            <tbody>
              @for (cliente of clientesRanking; track cliente.posicao) {
                <tr>
                  <td>
                    <span class="dashboard-resultados-rank">{{ cliente.posicao }}</span>{{ cliente.cliente }}
                    <small class="dashboard-resultados-row-subtitle">{{ cliente.documento }}</small>
                  </td>
                  <td class="text-right">{{ cliente.quantidade | number: '1.0-0' }} un</td>
                  <td class="text-right">{{ cliente.litros | number: '1.0-0' }} L</td>
                  <td class="text-right">{{ cliente.vendasReais | currency: 'BRL' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>

      <section class="dashboard-resultados-panel">
        <div class="dashboard-resultados-panel-header">
          <h2>Top 10 cidades</h2>
          <label class="dashboard-resultados-select">
            <span>Ordenar por</span>
            <select [(ngModel)]="ordenacaoCidades" (change)="atualizar()">
              <option value="quantidade">Quantidade</option>
              <option value="litros">Litros</option>
              <option value="valor">R$</option>
            </select>
          </label>
        </div>

        <div class="table-responsive">
          <table class="table table-sm dashboard-resultados-table mb-0">
            <thead>
              <tr>
                <th>Cidade</th>
                <th class="text-right">Qtde vendida</th>
                <th class="text-right">Litros</th>
                <th class="text-right">Vendas R$</th>
              </tr>
            </thead>
            <tbody>
              @for (cidade of cidadesRanking; track cidade.posicao) {
                <tr>
                  <td><span class="dashboard-resultados-rank">{{ cidade.posicao }}</span>{{ cidade.cidade }}</td>
                  <td class="text-right">{{ cidade.quantidade | number: '1.0-0' }} un</td>
                  <td class="text-right">{{ cidade.litros | number: '1.0-0' }} L</td>
                  <td class="text-right">{{ cidade.vendasReais | currency: 'BRL' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <app-dashboard-objetivos></app-dashboard-objetivos>
    }

    @if (abaAtiva === 'positivacao') {
    <div class="dashboard-resultados-positivacao-grid">
    <section class="dashboard-resultados-panel dashboard-resultados-positivacao">
      <div class="dashboard-resultados-panel-header">
        <div>
          <h2>Positivação de clientes</h2>
          <small>Clientes faturados por vendedor externo</small>
        </div>
      </div>

      <div class="dashboard-resultados-positivacao-cards">
        <div>
          <span>Total clientes</span>
          <b>{{ totalClientesPositivacao | number: '1.0-0' }}</b>
        </div>
        <div>
          <span>Positivação</span>
          <b>{{ totalClientesPositivados | number: '1.0-0' }}</b>
        </div>
        <div>
          <span>% Positivação</span>
          <b>{{ percentualPositivacaoGeral | number: '1.0-2' }}%</b>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm dashboard-resultados-table mb-0">
          <thead>
            <tr>
              <th>Vendedor</th>
              <th class="text-center">Total clientes</th>
              <th class="text-center">Positivação</th>
              <th>% Positivação</th>
            </tr>
          </thead>
          <tbody>
            @for (item of positivacaoClientes; track item.sellerId) {
              <tr>
                <td>{{ item.vendedor }}</td>
                <td class="text-center">{{ item.totalClientes | number: '1.0-0' }}</td>
                <td class="text-center">{{ item.positivacao | number: '1.0-0' }}</td>
                <td>
                  <div class="dashboard-resultados-positivacao-row">
                    <div class="dashboard-resultados-positivacao-track">
                      <div [style.width.%]="item.percentual > 100 ? 100 : item.percentual"></div>
                    </div>
                    <b>{{ item.percentual | number: '1.0-2' }}%</b>
                  </div>
                </td>
              </tr>
            }
            @if (positivacaoClientes.length == 0) {
              <tr>
                <td colspan="4" class="text-center dashboard-resultados-empty">Sem positivação para o periodo e filtros selecionados.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="dashboard-resultados-panel dashboard-resultados-positivacao">
      <div class="dashboard-resultados-panel-header">
        <div>
          <h2>Positivação de clientes ativos</h2>
          <small>Carteira nos níveis de relacionamento Ativo, Ativo Batido e Ativo Premium</small>
        </div>
      </div>

      <div class="dashboard-resultados-positivacao-cards">
        <div>
          <span>Total clientes ativos</span>
          <b>{{ totalClientesAtivosPositivacao | number: '1.0-0' }}</b>
        </div>
        <div>
          <span>Positivação</span>
          <b>{{ totalClientesAtivosPositivados | number: '1.0-0' }}</b>
        </div>
        <div>
          <span>% Positivação</span>
          <b>{{ percentualPositivacaoAtivos | number: '1.0-2' }}%</b>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm dashboard-resultados-table mb-0">
          <thead>
            <tr>
              <th>Vendedor</th>
              <th class="text-center">Clientes ativos</th>
              <th class="text-center">Positivação</th>
              <th>% Positivação</th>
            </tr>
          </thead>
          <tbody>
            @for (item of positivacaoClientesAtivos; track item.sellerId) {
              <tr>
                <td>{{ item.vendedor }}</td>
                <td class="text-center">{{ item.totalClientes | number: '1.0-0' }}</td>
                <td class="text-center">{{ item.positivacao | number: '1.0-0' }}</td>
                <td>
                  <div class="dashboard-resultados-positivacao-row">
                    <div class="dashboard-resultados-positivacao-track">
                      <div [style.width.%]="item.percentual > 100 ? 100 : item.percentual"></div>
                    </div>
                    <b>{{ item.percentual | number: '1.0-2' }}%</b>
                  </div>
                </td>
              </tr>
            }
            @if (positivacaoClientesAtivos.length == 0) {
              <tr>
                <td colspan="4" class="text-center dashboard-resultados-empty">Sem positivação de clientes ativos para o período e filtros selecionados.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
    </div>

    }

    @if (abaAtiva === 'abertura') {
    <section class="dashboard-resultados-panel dashboard-resultados-abertura-clientes">
      <div class="dashboard-resultados-panel-header">
        <div>
          <h2>Abertura de clientes com compra</h2>
          <small>São considerados clientes que nunca tinham comprado ou cuja última compra ocorreu há mais de 1 ano da data da compra.</small>
        </div>
      </div>

      @if (aberturaClientesCarregando) { <p role="status">Carregando abertura de clientes...</p> }
      @if (aberturaClientesExibida && !aberturaClientesCarregando) {
      <div class="dashboard-resultados-abertura-cards">
        <div>
          <span>Total de clientes</span>
          <b>{{ totalAberturaClientes | number: '1.0-0' }}</b>
        </div>
        <div>
          <span>Valor faturado</span>
          <b>R$ {{ totalAberturaClientesValor | number: '1.2-2' }}</b>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm dashboard-resultados-table dashboard-resultados-abertura-table mb-0">
          <thead>
            <tr>
              <th class="dashboard-resultados-expand-column"></th>
              <th>Vendedor</th>
              <th class="text-center">Total de clientes</th>
              <th class="text-right">Valor faturado</th>
            </tr>
          </thead>
          <tbody>
            @for (item of aberturaClientes; track item.sellerId) {
              <tr class="dashboard-resultados-abertura-summary">
                <td>
                  <button
                    class="dashboard-resultados-expand-button"
                    type="button"
                    [attr.aria-expanded]="!!aberturaClientesAbertos[item.sellerId]"
                    [title]="aberturaClientesAbertos[item.sellerId] ? 'Ocultar clientes' : 'Exibir clientes'"
                    (click)="alternarAberturaClientes(item)">
                    {{ aberturaClientesAbertos[item.sellerId] ? '−' : '+' }}
                  </button>
                </td>
                <td>{{ item.vendedor }}</td>
                <td class="text-center">{{ item.totalClientes | number: '1.0-0' }}</td>
                <td class="text-right">R$ {{ item.valorFaturado | number: '1.2-2' }}</td>
              </tr>
              @if (aberturaClientesAbertos[item.sellerId]) {
                <tr class="dashboard-resultados-abertura-details-row">
                  <td colspan="4">
                    <div class="table-responsive dashboard-resultados-abertura-details">
                      <table class="table table-sm dashboard-resultados-table mb-0">
                        <thead>
                          <tr>
                            <th>Cliente</th>
                            <th>Cód. ERP</th>
                            <th>Dt. compra</th>
                            <th>Dt. compra ant.</th>
                            <th class="text-right">Núm. pedido</th>
                            <th>Núm. NF</th>
                            <th class="text-right">Valor fat.</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (cliente of item.clientes; track cliente.clientId + '-' + cliente.numeroPedido) {
                            <tr>
                              <td>{{ cliente.cliente }}</td>
                              <td>{{ cliente.codigoErp || '-' }}</td>
                              <td>{{ cliente.dataCompra | date: 'dd/MM/yyyy' }}</td>
                              <td>{{ cliente.dataCompraAnterior ? (cliente.dataCompraAnterior | date: 'dd/MM/yyyy') : '-' }}</td>
                              <td class="text-right">{{ cliente.numeroPedido }}</td>
                              <td>{{ cliente.numeroNf || '-' }}</td>
                              <td class="text-right">R$ {{ cliente.valorFaturado | number: '1.2-2' }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              }
            }
            @if (aberturaClientes.length == 0) {
              <tr>
                <td colspan="4" class="text-center dashboard-resultados-empty">Nenhum cliente novo ou reativado no período e filtros selecionados.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      }
    </section>

    }
  </div>
}
